import { render, staticRenderFns } from "./hotel-details.vue?vue&type=template&id=636f4918&"
import script from "./hotel-details.vue?vue&type=script&lang=js&"
export * from "./hotel-details.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports